import { store } from '../store/storeMain'

export const accountManager = {

  getAccountByName(accountName) {
    let acc = JSON.parse(JSON.stringify(store.state.Accounts))

    for (let i = 0; i < acc.length; i++) {
      if (acc[i].accountName === accountName) {
        return acc[i]
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/javascript/accountManager.js